import { ProductCategoryType } from '@iota/iota-management-portal-v4-client';
import {
    ATTRIBUTE_CATEGORY_ORDER,
    IotaConfigAttributeCategory,
    IotaConfigAttributeCategoryLabel,
    IotaConfigAttributeScope,
    PRODUCT_CATEGORY_BOUND_ATTRIBUTE_CATEGORIES,
    SCOPED_ATTRIBUTE_CATEGORY_LABEL_OVERRIDES
} from 'src/app/shared/constants-and-enums/iota-config';

export function attributeCategoryLabel(scope: IotaConfigAttributeScope, category: string): string {
    return (
        SCOPED_ATTRIBUTE_CATEGORY_LABEL_OVERRIDES[scope]?.[category as IotaConfigAttributeCategory] ??
        IotaConfigAttributeCategoryLabel[category as IotaConfigAttributeCategory] ??
        category
    );
}

export function isAttributeCategoryAvailable(
    scope: IotaConfigAttributeScope,
    category: IotaConfigAttributeCategory,
    productCategory: ProductCategoryType | undefined
): boolean {
    const validProductCategories = PRODUCT_CATEGORY_BOUND_ATTRIBUTE_CATEGORIES[category];
    if (scope !== 'PRODUCT' || !validProductCategories) {
        return true;
    }
    return validProductCategories.includes(productCategory);
}

export function sortAttributeSections<T extends { key: string; label: string }>(sections: T[], otherAttributesKey: string): T[] {
    return [...sections].sort(
        (first, second) =>
            sectionRank(first.key, otherAttributesKey) - sectionRank(second.key, otherAttributesKey) ||
            first.label.localeCompare(second.label)
    );
}

function sectionRank(key: string, otherAttributesKey: string): number {
    if (key === otherAttributesKey) {
        return ATTRIBUTE_CATEGORY_ORDER.length + 1;
    }
    const position = ATTRIBUTE_CATEGORY_ORDER.indexOf(key as IotaConfigAttributeCategory);
    return position === -1 ? ATTRIBUTE_CATEGORY_ORDER.length : position;
}
